export default __webpack_public_path__ + "static/media/covid.d9e74b3e.svg";